import { Button } from '@mui/material'

const IconBtnV2 = ({
  icon, onClick, customStyle, ...props
}) => (
  <Button sx={[styles.root, customStyle && customStyle]} onClick={onClick} {...props}>
    {icon}
  </Button>
)

const styles = {
  root: {
    width: '30px',
    height: '30px',
    minWidth: 'unset',
    backgroundColor: '#f9f9f9',
    color: '#c1c1c1',
    borderRadius: '10px',
    '& svg': {
      fontSize: '18px',
    },
  },
}

export default IconBtnV2
